
import Header from './Header';
import DashBoardHeader from './DashBoardHeader';

export const MainHeader = ({ isLoggedIn, onLogout }) => {
  return (
    <header>
      {isLoggedIn ? <DashBoardHeader onLogout={onLogout} /> : <Header />}
    </header>
  );
};
